<template>
  <div class="relative container1400">
    <v-container>
      <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left">
        {{ $t(`s1651082238`) }}
      </h2>
      <v-form
        ref="form"
        class="pb-5"
        v-model="valid"
        @submit.prevent="next"
        lazy-validation
      >
        <v-card class="pa-7" min-height="300px">
          <v-row>
            <v-col v-for="(e, index) in questions" :key="index" cols="12">
              <p>
                {{ $t(e.qus) }}
              </p>
              <v-radio-group v-model="e.ans" :rules="reqRules" row>
                <v-radio label="Yes" value="Yes" row></v-radio>
                <v-radio label="No" value="No" row></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-item>
                <v-checkbox
                  v-model="data.agrement"
                  :rules="reqRules"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      {{ $t(`s1652189750`) }}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://member.nomadrooms.com/terms/partners-agreement/"
                            @click.stop
                            v-on="on"
                          >
                            {{ $t(`s1652367023`) }}
                          </a>
                        </template>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-item>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-container>
    <v-container>
      <div class="text-right">
        <v-btn large color="light-blue white--text" rounded @click="next">
          <span class="mr-2">{{ $t("Continue") }}</span>
          <v-icon size="small">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["data", "questions"],
  name: "Step0Component",
  components: {},
  data() {
    return {
      step0Error: false,
      valid: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  methods: {
    async next() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.data.questions = this.questions;
        this.data.steps = 1;
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>
